
import Axios from '@/services/api/axios';
import IContext from '@/services/api/i-context';
import axios from "axios"
// 是否允许跨域
axios.defaults.withCredentials = true;
declare let api: string

export default class ApiRequest {

    private context: IContext;
    private http: Axios;

    public constructor(context: IContext) {
        this.context = context
        this.http = new Axios(this.context)
    }

    public get Http() {
        return this.http
    }



    //获取验证码
    //获取验证码
    public async getCaptcha(key: string) {
        let instance = axios.create({
            baseURL: '/basicApi',
            timeout: 50000,
        });
        return instance({
            method: 'get',
            url: "/auth/captcha",
            params: { key: key },
            responseType: 'arraybuffer'
        })
    }
    //开始登录
    public async doLogin(data: any) {
        let instance = axios.create({
            baseURL: '/basicApi',
            timeout: 50000,
        });
        data = {
            username: data.username,
            password: data.password,
            // code: 'tianwanggaidihu',
            code: data.code,
            key: data.key,
            grant_type: 'password',
            Authorization:data.Authorization
        }
        var params = []
        for (var name in data) {
            if (name != "Authorization") {
                params.push(name + '=' + encodeURIComponent(data[name]))
            }

        }
        return instance({
            method: 'post',
            url: "/auth/oauth/token",
            data: params.join('&'),
            headers: {
                'Authorization': 'Basic ' + data.Authorization
            }
        })
    }
    //获取用户登录信息
    public async getUserInfo() {
        var result = await this.Http.get("/kebai-auth-sys/user/getUserInfoByUsername", {})
        return result
    }
    //获取当前机构信息
    public async selectByOrganizationCode(data:any) {
        var result = await this.http.get("/kebai-auth-sys/V1/organization/selectByOrganizationCode",{...data})
        return result
    } 
}


